import { katTranslator } from '../../shared/i18n';

const strings = {
  'currency-selector-AED': {
    'ar-AE': 'درهم إماراتي',
    'bn-IN': 'সংযুক্ত আরব আমিরাত দিরহাম',
    'cs-CZ': 'Emirátský dirham',
    'da-DK': 'De Forenede Arabiske Emirater Dirham',
    'de-DE': 'VAE-Dirham',
    'en-AE': 'United Arab Emirates Dirham',
    'en-AU': 'United Arab Emirates Dirham',
    'en-CA': 'United Arab Emirates Dirham',
    'en-GB': 'United Arab Emirates Dirham',
    'en-IN': 'United Arab Emirates Dirham',
    'en-NG': 'United Arab Emirates Dirham',
    'en-SG': 'United Arab Emirates Dirham',
    'en-US': 'United Arab Emirates Dirham',
    'en-ZA': 'United Arab Emirates Dirham',
    'es-CL': 'Dirham de los Emiratos Árabes Unidos',
    'es-CO': 'Dirham de Emiratos Árabes Unidos',
    'es-ES': 'Dírham de Emiratos Árabes Unidos',
    'es-MX': 'Dirham emiratí',
    'es-US': 'Dirham de Emiratos Árabes Unidos',
    'fr-BE': 'Dirham des Émirats Arabes Unis',
    'fr-CA': 'Dirham des Émirats arabes unis',
    'fr-FR': 'Dirham des Émirats arabes unis',
    'he-IL': 'דירהם איחוד האמירויות הערביות',
    'hi-IN': 'संयुक्त अरब अमीरात दिरहम',
    'it-IT': 'Dirham degli Emirati Arabi Uniti',
    'ja-JP': 'アラブ首長国連邦ディルハム',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಅರಬ್ ಎಮಿರೇಟ್ಸ್ ದಿರ್ಹಮ್',
    'ko-KR': '아랍 에미리트 연합국 디르함',
    'ml-IN': 'യുണൈറ്റഡ് അറബ് എമിറേറ്റ്സ് ദിർഹം',
    'mr-IN': 'संयुक्त अरब अमिराती दिरहॅम',
    'nl-BE': 'Verenigde Arabische Emiraten dirham',
    'nl-NL': 'Verenigde Arabische Emiraten dirham',
    'pl-PL': 'Dirham Zjednoczonych Emiratów Arabskich',
    'pt-BR': 'Dirham dos Emirados Árabes Unidos',
    'pt-PT': 'Dirham dos Emiratos Árabes Unidos',
    'sv-SE': 'Emiratisk dirham',
    'ta-IN': 'ஐக்கிய அரபு அமீரக டர்ஹாம்',
    'te-IN': 'యునైటెడ్ అరబ్ ఎమిరేట్స్ దిర్హామ్',
    'tr-TR': 'Birleşik Arap Emirlikleri Dirhemi',
    'zh-CN': '阿联酋迪拉姆',
    'zh-TW': 'AED-阿拉伯聯合大公國迪拉姆',
  },
  'currency-selector-AUD': {
    'ar-AE': 'دولار أسترالي',
    'bn-IN': 'অস্ট্রেলিয়ান ডলার',
    'cs-CZ': 'Australský dolar',
    'da-DK': 'Australske dollar',
    'de-DE': 'Australischer Dollar',
    'en-AE': 'Australian Dollar',
    'en-AU': 'Australian Dollar',
    'en-CA': 'Australian Dollar',
    'en-GB': 'Australian Dollar',
    'en-IN': 'Australian Dollar',
    'en-NG': 'Australian Dollar',
    'en-SG': 'Australian Dollar',
    'en-US': 'Australian Dollar',
    'en-ZA': 'Australian Dollar',
    'es-CL': 'Dólar australiano',
    'es-CO': 'Dólar australiano',
    'es-ES': 'Dólar australiano',
    'es-MX': 'Dólar australiano',
    'es-US': 'Dólar australiano',
    'fr-BE': 'Dollar australien',
    'fr-CA': 'Dollar australien',
    'fr-FR': 'Dollar australien',
    'he-IL': 'דולר אוסטרליה',
    'hi-IN': 'ऑस्ट्रेलियाई डॉलर',
    'it-IT': 'Dollaro australiano',
    'ja-JP': 'オーストリアドル',
    'kn-IN': 'ಆಸ್ಟ್ರೇಲಿಯನ್ ಡಾಲರ್',
    'ko-KR': '호주 달러',
    'ml-IN': 'ഓസ്‌ട്രേലിയൻ ഡോളർ',
    'mr-IN': 'ऑस्ट्रेलियन डॉलर',
    'nl-BE': 'Australische dollar',
    'nl-NL': 'Australische dollar',
    'pl-PL': 'Dolar australijski',
    'pt-BR': 'Dólar australiano',
    'pt-PT': 'Dólar australiano',
    'sv-SE': 'Australisk dollar',
    'ta-IN': 'ஆஸ்திரேலியன் டாலர்',
    'te-IN': 'ఆస్ట్రేలియన్ డాలర్',
    'tr-TR': 'Avustralya Doları',
    'zh-CN': '澳元',
    'zh-TW': '澳幣',
  },
  'currency-selector-BGN': {
    'ar-AE': 'ليف بلغاري',
    'bn-IN': 'বুলগেরিয়ান লেভ',
    'cs-CZ': 'Bulharský lev',
    'da-DK': 'Bulgarske Lev',
    'de-DE': 'Bulgarischer Lew',
    'en-AE': 'Bulgarian Lev',
    'en-AU': 'Bulgarian Lev',
    'en-CA': 'Bulgarian Lev',
    'en-GB': 'Bulgarian Lev',
    'en-IN': 'Bulgarian Lev',
    'en-NG': 'Bulgarian Lev',
    'en-SG': 'Bulgarian Lev',
    'en-US': 'Bulgarian Lev',
    'en-ZA': 'Bulgarian Lev',
    'es-CL': 'Leva búlgara',
    'es-CO': 'Lev búlgaro',
    'es-ES': 'Leva búlgara',
    'es-MX': 'Lev búlgaro',
    'es-US': 'Lev búlgaro',
    'fr-BE': 'Lev bulgare',
    'fr-CA': 'Lev bulgare',
    'fr-FR': 'Lev bulgare',
    'he-IL': 'לב בולגרי',
    'hi-IN': 'बल्गेरियाई लेव',
    'it-IT': 'Lev bulgaro',
    'ja-JP': 'ブルガリアレフ',
    'kn-IN': 'ಬಲ್ಗೇರಿಯನ್ ಲೆವ್',
    'ko-KR': '불가리아 레프',
    'ml-IN': 'ബൾഗേറിയൻ ലെവ്',
    'mr-IN': 'बल्गेरियन लेव्ह',
    'nl-BE': 'Bulgaarse lev',
    'nl-NL': 'Bulgaarse lev',
    'pl-PL': 'Lew bułgarski',
    'pt-BR': 'Lev búlgaro',
    'pt-PT': 'Lev búlgaro',
    'sv-SE': 'Bulgarisk lev',
    'ta-IN': 'பல்கேரியன் லெவ்',
    'te-IN': 'బల్గేరియా లెవ్',
    'tr-TR': 'Bulgar Levası',
    'zh-CN': '保加利亚列弗',
    'zh-TW': '保加利亞列弗',
  },
  'currency-selector-BRL': {
    'ar-AE': 'ريال برازيلي',
    'bn-IN': 'ব্রাজিলিয়ান রিয়েল',
    'cs-CZ': 'Brazilský real',
    'da-DK': 'Brasilianske real',
    'de-DE': 'Brasilianischer Real',
    'en-AE': 'Brazilian Real',
    'en-AU': 'Brazilian Real',
    'en-CA': 'Brazilian Real',
    'en-GB': 'Brazilian Real',
    'en-IN': 'Brazilian Real',
    'en-NG': 'Brazilian Real',
    'en-SG': 'Brazilian Real',
    'en-US': 'Brazilian Real',
    'en-ZA': 'Brazilian Real',
    'es-CL': 'Real brasileño',
    'es-CO': 'Real brasileño',
    'es-ES': 'Real brasileño',
    'es-MX': 'Real brasileño',
    'es-US': 'Real brasileño',
    'fr-BE': 'Réal brésilien',
    'fr-CA': 'Réal brésilien',
    'fr-FR': 'Réal brésilien',
    'he-IL': 'ריאל ברזילאי',
    'hi-IN': 'ब्राज़ीली रियाल',
    'it-IT': 'Real brasiliano',
    'ja-JP': 'ブラジルレアル',
    'kn-IN': 'ಬ್ರೆಜಿಲ್‌ನ ರಿಯಾಲ್',
    'ko-KR': '브라질 헤알',
    'ml-IN': 'ബ്രസീലിയൻ റിയൽ',
    'mr-IN': 'ब्राझिलियन रिआल',
    'nl-BE': 'Braziliaanse real',
    'nl-NL': 'Braziliaanse real',
    'pl-PL': 'Real brazylijski',
    'pt-BR': 'Real brasileiro',
    'pt-PT': 'Real do Brasil',
    'sv-SE': 'Brasiliansk real',
    'ta-IN': 'பிரேசிலியன் ரியால்',
    'te-IN': 'బ్రెజిలియన్ రియల్',
    'tr-TR': 'Brezilya Reali',
    'zh-CN': '巴西雷亚尔',
    'zh-TW': '巴西雷亞爾',
  },
  'currency-selector-CAD': {
    'ar-AE': 'دولار كندي',
    'bn-IN': 'কানাডিয়ান ডলার',
    'cs-CZ': 'Kanadský dolar',
    'da-DK': 'Canadiske dollar',
    'de-DE': 'Kanadischer Dollar',
    'en-AE': 'Canadian Dollar',
    'en-AU': 'Canadian Dollar',
    'en-CA': 'Canadian Dollar',
    'en-GB': 'Canadian Dollar',
    'en-IN': 'Canadian Dollar',
    'en-NG': 'Canadian Dollar',
    'en-SG': 'Canadian Dollar',
    'en-US': 'Canadian Dollar',
    'en-ZA': 'Canadian Dollar',
    'es-CL': 'Dólar canadiense',
    'es-CO': 'Dólar canadiense',
    'es-ES': 'Dólar canadiense',
    'es-MX': 'Dólar canadiense',
    'es-US': 'Dólar canadiense',
    'fr-BE': 'Dollar canadien',
    'fr-CA': 'Dollar canadien',
    'fr-FR': 'Dollar canadien',
    'he-IL': 'דולר קנדי',
    'hi-IN': 'कैनेडियन डॉलर',
    'it-IT': 'Dollaro canadese',
    'ja-JP': 'カナダドル',
    'kn-IN': 'ಕೆನಡಾದ ಡಾಲರ್',
    'ko-KR': '캐나다 달러',
    'ml-IN': 'കനേഡിയൻ ഡോളർ',
    'mr-IN': 'कॅनेडियन डॉलर',
    'nl-BE': 'Canadese dollar',
    'nl-NL': 'Canadese dollar',
    'pl-PL': 'Dolar kanadyjski',
    'pt-BR': 'Dólar canadense',
    'pt-PT': 'Dólar canadiano',
    'sv-SE': 'Kanadensisk dollar',
    'ta-IN': 'கனடிய டாலர்',
    'te-IN': 'కెనడియన్ డాలర్',
    'tr-TR': 'Kanada Doları',
    'zh-CN': '加拿大元',
    'zh-TW': '加幣',
  },
  'currency-selector-CHF': {
    'ar-AE': 'فرنك سويسري',
    'bn-IN': 'সুইস ফ্রাঙ্ক',
    'cs-CZ': 'Švýcarský frank',
    'da-DK': 'Schweiziske franc',
    'de-DE': 'Schweizer Franken',
    'en-AE': 'Swiss Franc',
    'en-AU': 'Swiss Franc',
    'en-CA': 'Swiss Franc',
    'en-GB': 'Swiss Franc',
    'en-IN': 'Swiss Franc',
    'en-NG': 'Swiss Franc',
    'en-SG': 'Swiss Franc',
    'en-US': 'Swiss Franc',
    'en-ZA': 'Swiss Franc',
    'es-CL': 'Franco suizo',
    'es-CO': 'Franco suizo',
    'es-ES': 'Franco suizo',
    'es-MX': 'Franco suizo',
    'es-US': 'Franco suizo',
    'fr-BE': 'Franc suisse',
    'fr-CA': 'Franc suisse',
    'fr-FR': 'Franc suisse',
    'he-IL': 'פרנק שוויצרי',
    'hi-IN': 'स्विस फ़्रैंक',
    'it-IT': 'Franco svizzero',
    'ja-JP': 'スイスフラン',
    'kn-IN': 'ಸ್ವಿಸ್ ಫ್ರಾಂಕ್',
    'ko-KR': '스위스 프랑',
    'ml-IN': 'സ്വിസ് ഫ്രാങ്ക്',
    'mr-IN': 'स्विस फ्रँक',
    'nl-BE': 'Zwitserse frank',
    'nl-NL': 'Zwitserse frank',
    'pl-PL': 'Frank szwajcarski',
    'pt-BR': 'Franco suíço',
    'pt-PT': 'Franco suíço',
    'sv-SE': 'Schweizisk franc',
    'ta-IN': 'சுவிஸ் ஃபிராங்க்',
    'te-IN': 'స్విస్ ఫ్రాంక్',
    'tr-TR': 'İsviçre Frangı',
    'zh-CN': '瑞士法郎',
    'zh-TW': '瑞士法郎',
  },
  'currency-selector-CLP': {
    'ar-AE': 'بيزو تشيلي',
    'bn-IN': 'চিলিয়ান পেসো',
    'cs-CZ': 'Chilské peso',
    'da-DK': 'Chilenske pesos',
    'de-DE': 'Chilenischer Peso',
    'en-AE': 'Chilean Peso',
    'en-AU': 'Chilean Peso',
    'en-CA': 'Chilean Peso',
    'en-GB': 'Chilean Peso',
    'en-IN': 'Chilean Peso',
    'en-NG': 'Chilean Peso',
    'en-SG': 'Chilean Peso',
    'en-US': 'Chilean Peso',
    'en-ZA': 'Chilean Peso',
    'es-CL': 'Peso chileno',
    'es-CO': 'Peso chileno',
    'es-ES': 'Peso chileno',
    'es-MX': 'Peso chileno',
    'es-US': 'Peso chileno',
    'fr-BE': 'Peso chilien',
    'fr-CA': 'Peso chilien',
    'fr-FR': 'Peso chilien',
    'he-IL': "פסו צ'יליאני",
    'hi-IN': 'चिलीयन पेसो',
    'it-IT': 'Peso cileno',
    'ja-JP': 'チリペソ',
    'kn-IN': 'ಚಿಲಿಯನ್ ಪೆಸೊ',
    'ko-KR': '칠레 페소',
    'ml-IN': 'ചിലിയൻ പെസോ',
    'mr-IN': 'चिलीयन पेसो',
    'nl-BE': 'Chileense peso',
    'nl-NL': 'Chileense peso',
    'pl-PL': 'Peso chilijskie',
    'pt-BR': 'Peso chileno',
    'pt-PT': 'Peso chileno',
    'sv-SE': 'Chilensk peso',
    'ta-IN': 'சிலியன் பெசோ',
    'te-IN': 'చిలియన్ పెసో',
    'tr-TR': 'Şili Pesosu',
    'zh-CN': '智利比索',
    'zh-TW': '智利披索',
  },
  'currency-selector-CNY': {
    'ar-AE': 'يوان صيني',
    'bn-IN': 'চাইনিজ ইউয়ান',
    'cs-CZ': 'Čínský jüan',
    'da-DK': 'Kinesiske yuan',
    'de-DE': 'Chinesischer Yuan',
    'en-AE': 'Chinese Yuan',
    'en-AU': 'Chinese Yuan',
    'en-CA': 'Chinese Yuan',
    'en-GB': 'Chinese Yuan',
    'en-IN': 'Chinese Yuan',
    'en-NG': 'Chinese Yuan',
    'en-SG': 'Chinese Yuan',
    'en-US': 'Chinese Yuan',
    'en-ZA': 'Chinese Yuan',
    'es-CL': 'Yuan chino',
    'es-CO': 'Yuan chino',
    'es-ES': 'Yuan chino',
    'es-MX': 'Yuan chino',
    'es-US': 'Yuan chino',
    'fr-BE': 'Yuan chinois',
    'fr-CA': 'Yuan chinois',
    'fr-FR': 'Yuan chinois',
    'he-IL': 'יואן סיני',
    'hi-IN': 'चीनी युआन',
    'it-IT': 'Yuan cinese',
    'ja-JP': '中国元',
    'kn-IN': 'ಚೈನೀಸ್ ಯುವಾನ್',
    'ko-KR': '중국 위안',
    'ml-IN': 'ചൈനീസ് യുവാൻ',
    'mr-IN': 'चिनी युआन',
    'nl-BE': 'Chinese yuan',
    'nl-NL': 'Chinese yuan',
    'pl-PL': 'Juan chiński',
    'pt-BR': 'Yuan chinês',
    'pt-PT': 'Yuan chinês',
    'sv-SE': 'Kinesisk renminbi',
    'ta-IN': 'சீன யுவான்',
    'te-IN': 'చైనీస్ యువాన్',
    'tr-TR': 'Çin Yuanı',
    'zh-CN': '人民币',
    'zh-TW': '人民幣',
  },
  'currency-selector-COP': {
    'ar-AE': 'بيزو كولومبي',
    'bn-IN': 'কলম্বিয়ান পেসো',
    'cs-CZ': 'Kolumbijské peso',
    'da-DK': 'Colombianske pesos',
    'de-DE': 'Kolumbianischer Peso',
    'en-AE': 'Colombian Peso',
    'en-AU': 'Colombian Peso',
    'en-CA': 'Colombian Peso',
    'en-GB': 'Colombian Peso',
    'en-IN': 'Colombian Peso',
    'en-NG': 'Colombian Peso',
    'en-SG': 'Colombian Peso',
    'en-US': 'Colombian Peso',
    'en-ZA': 'Colombian Peso',
    'es-CL': 'Peso colombiano',
    'es-CO': 'Peso colombiano',
    'es-ES': 'Peso colombiano',
    'es-MX': 'Peso colombiano',
    'es-US': 'Peso colombiano',
    'fr-BE': 'Peso colombien',
    'fr-CA': 'Peso colombien',
    'fr-FR': 'Peso colombien',
    'he-IL': 'פסו קולומביאני',
    'hi-IN': 'कोलम्बियाई पेसो',
    'it-IT': 'Peso colombiano',
    'ja-JP': 'コロンビア・ペソ',
    'kn-IN': 'ಕೊಲಂಬಿಯನ್ ಪೆಸೊ',
    'ko-KR': '콜롬비아 페소',
    'ml-IN': 'കൊളംബിയൻ പെസോ',
    'mr-IN': 'कोलंबियन पेसो',
    'nl-BE': 'Colombiaanse peso',
    'nl-NL': 'Colombiaanse peso',
    'pl-PL': 'Peso kolumbijskie',
    'pt-BR': 'Peso colombiano',
    'pt-PT': 'Peso colombiano',
    'sv-SE': 'Colombiansk peso',
    'ta-IN': 'கொலம்பியன் பெசோ',
    'te-IN': 'కొలంబియన్ పెసో',
    'tr-TR': 'Kolombiya Pesosu',
    'zh-CN': '哥伦比亚比索',
    'zh-TW': '哥倫比亞披索',
  },
  'currency-selector-DKK': {
    'ar-AE': 'كرونة دنماركية',
    'bn-IN': 'ড্যানিশ ক্রোন',
    'cs-CZ': 'Dánská koruna',
    'da-DK': 'Danske kroner',
    'de-DE': 'Dänische Krone',
    'en-AE': 'Danish Krone',
    'en-AU': 'Danish Krone',
    'en-CA': 'Danish Krone',
    'en-GB': 'Danish Krone',
    'en-IN': 'Danish Krone',
    'en-NG': 'Danish Krone',
    'en-SG': 'Danish Krone',
    'en-US': 'Danish Krone',
    'en-ZA': 'Danish Krone',
    'es-CL': 'Corona danesa',
    'es-CO': 'Corona danesa',
    'es-ES': 'Corona danesa',
    'es-MX': 'Corona danesa',
    'es-US': 'Corona danesa',
    'fr-BE': 'Couronne danoise',
    'fr-CA': 'Couronne danoise',
    'fr-FR': 'Couronne danoise',
    'he-IL': 'קרונה דנית',
    'hi-IN': 'डेनिश क्रोन',
    'it-IT': 'Corona danese',
    'ja-JP': 'デンマーククローネ',
    'kn-IN': 'ಡ್ಯಾನಿಶ್‌ ಕ್ರೋನ್',
    'ko-KR': '덴마크 크로네',
    'ml-IN': 'ഡാനിഷ് ക്രോണെ',
    'mr-IN': 'डॅनिश क्रोन',
    'nl-BE': 'Deense kroon',
    'nl-NL': 'Deense kroon',
    'pl-PL': 'Korona duńska',
    'pt-BR': 'Coroa dinamarquesa',
    'pt-PT': 'Coroa dinamarquesa',
    'sv-SE': 'Dansk krona',
    'ta-IN': 'டேனிஷ் க்ரோன்',
    'te-IN': 'డానిష్ క్రోన్',
    'tr-TR': 'Danimarka Kronu',
    'zh-CN': '丹麦克朗',
    'zh-TW': '丹麥克朗',
  },
  'currency-selector-EGP': {
    'ar-AE': 'جنيه مصري',
    'bn-IN': 'মিশরীয় পাউন্ড',
    'cs-CZ': 'Egyptská libra',
    'da-DK': 'Egyptiske pund',
    'de-DE': 'Ägyptisches Pfund',
    'en-AE': 'Egyptian Pound',
    'en-AU': 'Egyptian Pound',
    'en-CA': 'Egyptian Pound',
    'en-GB': 'Egyptian Pound',
    'en-IN': 'Egyptian Pound',
    'en-NG': 'Egyptian Pound',
    'en-SG': 'Egyptian Pound',
    'en-US': 'Egyptian Pound',
    'en-ZA': 'Egyptian Pound',
    'es-CL': 'Libra egipcia',
    'es-CO': 'Libra egipcia',
    'es-ES': 'Libra egipcia',
    'es-MX': 'Libra egipcia',
    'es-US': 'Libra egipcia',
    'fr-BE': 'Livre égyptienne',
    'fr-CA': 'Livre égyptienne',
    'fr-FR': 'Livre égyptienne',
    'he-IL': 'לירה מצרית',
    'hi-IN': 'मिस्री पाउंड',
    'it-IT': 'Sterlina egiziana',
    'ja-JP': 'エジプトポンド',
    'kn-IN': 'ಈಜಿಪ್ಟ್‌ನ ಪೌಂಡ್',
    'ko-KR': '이집트 파운드',
    'ml-IN': 'ഈജിപ്ഷ്യൻ പൗണ്ട്',
    'mr-IN': 'इजिप्शियन पौंड',
    'nl-BE': 'Egyptische ponden',
    'nl-NL': 'Egyptische pond',
    'pl-PL': 'Funt egipski',
    'pt-BR': 'Libra egípcia',
    'pt-PT': 'Libra egípcia',
    'sv-SE': 'Egyptiskt pund',
    'ta-IN': 'எகிப்தியன் பவுண்டு',
    'te-IN': 'ఈజిప్షియన్ పౌండ్',
    'tr-TR': 'Mısır Lirası',
    'zh-CN': '埃及镑',
    'zh-TW': '埃及鎊',
  },
  'currency-selector-EUR': {
    'ar-AE': 'يورو',
    'bn-IN': 'ইউরো',
    'cs-CZ': 'Euro',
    'da-DK': 'Euro',
    'de-DE': 'Euro',
    'en-AE': 'Euro',
    'en-AU': 'Euro',
    'en-CA': 'Euro',
    'en-GB': 'Euro',
    'en-IN': 'Euro',
    'en-NG': 'Euro',
    'en-SG': 'Euro',
    'en-US': 'Euro',
    'en-ZA': 'Euro',
    'es-CL': 'Euro',
    'es-CO': 'Euro',
    'es-ES': 'Euro',
    'es-MX': 'Euro',
    'es-US': 'Euro',
    'fr-BE': 'Euro',
    'fr-CA': 'Euro',
    'fr-FR': 'Euro',
    'he-IL': 'יורו',
    'hi-IN': 'यूरो',
    'it-IT': 'Euro',
    'ja-JP': 'ユーロ',
    'kn-IN': 'ಯೂರೋ',
    'ko-KR': '유로',
    'ml-IN': 'യൂറോ',
    'mr-IN': 'युरो',
    'nl-BE': 'euro',
    'nl-NL': 'Euro',
    'pl-PL': 'Euro',
    'pt-BR': 'Euro',
    'pt-PT': 'Euro',
    'sv-SE': 'Euro',
    'ta-IN': 'யூரோ',
    'te-IN': 'యూరో',
    'tr-TR': 'Avro',
    'zh-CN': '欧元',
    'zh-TW': '歐元',
  },
  'currency-selector-GBP': {
    'ar-AE': 'جنيه إسترليني',
    'bn-IN': 'পাউন্ড স্টার্লিং',
    'cs-CZ': 'Libra šterlinků',
    'da-DK': 'Pund sterling',
    'de-DE': 'Pfund Sterling',
    'en-AE': 'Pound Sterling',
    'en-AU': 'Pound Sterling',
    'en-CA': 'Pound Sterling',
    'en-GB': 'Pound Sterling',
    'en-IN': 'Pound Sterling',
    'en-NG': 'Pound Sterling',
    'en-SG': 'Pound Sterling',
    'en-US': 'Pound Sterling',
    'en-ZA': 'Pound Sterling',
    'es-CL': 'Libra esterlina',
    'es-CO': 'Libra esterlina',
    'es-ES': 'Libra esterlina',
    'es-MX': 'Libra esterlina',
    'es-US': 'Libra esterlina',
    'fr-BE': 'Livre sterling',
    'fr-CA': 'Livre Sterling',
    'fr-FR': 'Livre sterling',
    'he-IL': 'לירה שטרלינג',
    'hi-IN': 'पाउंड स्टर्लिंग',
    'it-IT': 'Sterlina inglese',
    'ja-JP': 'スターリングポンド',
    'kn-IN': 'ಪೌಂಡ್ ಸ್ಟರ್ಲಿಂಗ್',
    'ko-KR': '파운드 스털링',
    'ml-IN': 'പൗണ്ട് സ്റ്റെർലിങ്',
    'mr-IN': 'पाउंड स्टर्लिंग',
    'nl-BE': 'pond sterling',
    'nl-NL': 'Pond sterling',
    'pl-PL': 'Brytyjski funt szterling',
    'pt-BR': 'Libra esterlina',
    'pt-PT': 'Libra esterlina',
    'sv-SE': 'Brittiskt pund',
    'ta-IN': 'பவுண்டு ஸ்டெர்லிங்',
    'te-IN': 'పౌండ్ స్టెర్లింగ్',
    'tr-TR': 'İngiliz Sterlini',
    'zh-CN': '英镑',
    'zh-TW': '英鎊',
  },
  'currency-selector-HKD': {
    'ar-AE': 'دولار هونغ كونغ',
    'bn-IN': 'হংকং ডলার',
    'cs-CZ': 'Hongkongský dolar',
    'da-DK': 'Hong Kong Dollar',
    'de-DE': 'Hongkong-Dollar',
    'en-AE': 'Hong Kong Dollar',
    'en-AU': 'Hong Kong Dollar',
    'en-CA': 'Hong Kong Dollar',
    'en-GB': 'Hong Kong Dollar',
    'en-IN': 'Hong Kong Dollar',
    'en-NG': 'Hong Kong Dollar',
    'en-SG': 'Hong Kong Dollar',
    'en-US': 'Hong Kong Dollar',
    'en-ZA': 'Hong Kong Dollar',
    'es-CL': 'Dólar de Hong Kong',
    'es-CO': 'Dólar de Hong Kong',
    'es-ES': 'Dólar de Hong Kong',
    'es-MX': 'Dólar hongkonés',
    'es-US': 'Dólar de Hong Kong',
    'fr-BE': 'Dollar de Hong Kong',
    'fr-CA': 'Dollar de Hong Kong',
    'fr-FR': 'Dollar de Hong Kong',
    'he-IL': 'דולר הונג קונג',
    'hi-IN': 'हांग कांग डॉलर',
    'it-IT': 'Dollaro di Hong Kong',
    'ja-JP': '香港ドル',
    'kn-IN': 'ಹಾಂಗ್ ಕಾಂಗ್ ಡಾಲರ್',
    'ko-KR': '홍콩 달러',
    'ml-IN': 'ഹോങ്കോംഗ് ഡോളർ',
    'mr-IN': 'हाँगकाँग डॉलर',
    'nl-BE': 'Hongkongse dollar',
    'nl-NL': 'Hongkongse dollar',
    'pl-PL': 'Dolar hongkoński',
    'pt-BR': 'Dólar de Hong Kong',
    'pt-PT': 'Dólar de Hong Kong',
    'sv-SE': 'Hongkongdollar',
    'ta-IN': 'ஹாங்காங் டாலர்',
    'te-IN': 'హాంగ్ కాంగ్ డాలర్',
    'tr-TR': 'Hong Kong Doları',
    'zh-CN': '港元',
    'zh-TW': '港幣',
  },
  'currency-selector-ILS': {
    'ar-AE': 'شيكل إسرائيلي',
    'bn-IN': 'ইজরায়েলি শেকেল',
    'cs-CZ': 'Izraelský šekel',
    'da-DK': 'Israelske shekel',
    'de-DE': 'Israelischer Schekel',
    'en-AE': 'Israeli Shekel',
    'en-AU': 'Israeli Shekel',
    'en-CA': 'Israeli Shekel',
    'en-GB': 'Israeli Shekel',
    'en-IN': 'Israeli Shekel',
    'en-NG': 'Israeli Shekel',
    'en-SG': 'Israeli Shekel',
    'en-US': 'Israeli Shekel',
    'en-ZA': 'Israeli Shekel',
    'es-CL': 'Nuevo séquel israelí',
    'es-CO': 'Nuevo séquel israelí',
    'es-ES': 'Séquel israelí',
    'es-MX': 'Nuevo séquel israelí',
    'es-US': 'Nuevo séquel israelí',
    'fr-BE': 'Shekel israélien',
    'fr-CA': 'Shekel israélien',
    'fr-FR': 'Shekel israélien',
    'he-IL': 'שקל ישראלי',
    'hi-IN': 'इज़राइल शेकेल',
    'it-IT': 'Shekel israeliano',
    'ja-JP': 'イスラエルシェケル',
    'kn-IN': 'ಇಸ್ರೇಲಿ‌ ಶೇಖಲ್',
    'ko-KR': '이스라엘 셰켈',
    'ml-IN': 'ഇസ്രയേലി ഷെക്കൽ',
    'mr-IN': 'इस्रायली शेकेल',
    'nl-BE': 'Israëlische sjekel',
    'nl-NL': 'Israëlische sjekel',
    'pl-PL': 'Szekel izraelski',
    'pt-BR': 'Shekel israelense',
    'pt-PT': 'Shekel de Israel',
    'sv-SE': 'Israelisk shekel',
    'ta-IN': 'இஸ்ரேலிய ஷெகல்',
    'te-IN': 'ఇజ్రాయిల్ షెకెల్',
    'tr-TR': 'Yeni İsrail Şekeli',
    'zh-CN': '以色列镑',
    'zh-TW': '以色列新謝克爾',
  },
  'currency-selector-INR': {
    'ar-AE': 'روبية هندية',
    'bn-IN': 'ভারতীয় টাকা',
    'cs-CZ': 'Indická rupie',
    'da-DK': 'Indiske rupee',
    'de-DE': 'Indische Rupie',
    'en-AE': 'Indian Rupee',
    'en-AU': 'Indian Rupee',
    'en-CA': 'Indian Rupee',
    'en-GB': 'Indian Rupee',
    'en-IN': 'Indian Rupee',
    'en-NG': 'Indian Rupee',
    'en-SG': 'Indian Rupee',
    'en-US': 'Indian Rupee',
    'en-ZA': 'Indian Rupee',
    'es-CL': 'Rupia india',
    'es-CO': 'Rupia india',
    'es-ES': 'Rupia india',
    'es-MX': 'Rupia india',
    'es-US': 'Rupia india',
    'fr-BE': 'Roupie indienne',
    'fr-CA': 'Roupie indienne',
    'fr-FR': 'Roupie indienne',
    'he-IL': 'רופי הודי',
    'hi-IN': 'भारतीय रुपया',
    'it-IT': 'Rupia indiana',
    'ja-JP': 'インドルピー',
    'kn-IN': 'ಭಾರತದ ರೂಪಾಯಿ',
    'ko-KR': '인도 루피',
    'ml-IN': 'ഇന്ത്യൻ രൂപ',
    'mr-IN': 'भारतीय रुपया',
    'nl-BE': 'Indiase roepie',
    'nl-NL': 'Indiase roepie',
    'pl-PL': 'Rupia indyjska',
    'pt-BR': 'Rúpia indiana',
    'pt-PT': 'Rupia indiana',
    'sv-SE': 'Indisk rupie',
    'ta-IN': 'இந்திய ரூபாய்',
    'te-IN': 'ఇండియన్ రూపీ',
    'tr-TR': 'Hindistan Rupisi',
    'zh-CN': '印度卢比',
    'zh-TW': '印度盧比',
  },
  'currency-selector-JPY': {
    'ar-AE': 'ين ياباني',
    'bn-IN': 'জাপানি ইয়েন',
    'cs-CZ': 'Japonský jen',
    'da-DK': 'Japanske yen',
    'de-DE': 'Japanischer Yen',
    'en-AE': 'Japanese Yen',
    'en-AU': 'Japanese Yen',
    'en-CA': 'Japanese Yen',
    'en-GB': 'Japanese Yen',
    'en-IN': 'Japanese Yen',
    'en-NG': 'Japanese Yen',
    'en-SG': 'Japanese Yen',
    'en-US': 'Japanese Yen',
    'en-ZA': 'Japanese Yen',
    'es-CL': 'Yen japonés',
    'es-CO': 'Yen japonés',
    'es-ES': 'Yen japonés',
    'es-MX': 'Yen japonés',
    'es-US': 'Yen japonés',
    'fr-BE': 'Yen japonais',
    'fr-CA': 'Yen japonais',
    'fr-FR': 'Yen japonais',
    'he-IL': 'ין יפני',
    'hi-IN': 'जापानी येन',
    'it-IT': 'Yen giapponese',
    'ja-JP': '日本円',
    'kn-IN': 'ಜಪಾನ್‌ನ ಯೆನ್',
    'ko-KR': '일본 엔',
    'ml-IN': 'ജാപ്പനീസ് യെൻ',
    'mr-IN': 'जपानी येन',
    'nl-BE': 'Japanse yen',
    'nl-NL': 'Japanse yen',
    'pl-PL': 'Jen japoński',
    'pt-BR': 'Iene japonês',
    'pt-PT': 'Iene japonês',
    'sv-SE': 'Japansk yen',
    'ta-IN': 'ஜப்பானீஸ் யென்',
    'te-IN': 'జపనీస్ యెన్',
    'tr-TR': 'Japon Yeni',
    'zh-CN': '日元',
    'zh-TW': '日圓',
  },
  'currency-selector-KRW': {
    'ar-AE': 'وون كوري جنوبي',
    'bn-IN': 'দক্ষিণ কোরিয়ান ওন',
    'cs-CZ': 'Jihokorejský won',
    'da-DK': 'Sydkoreanske won',
    'de-DE': 'Südkoreanischer Won',
    'en-AE': 'South Korean Won',
    'en-AU': 'South Korean Won',
    'en-CA': 'South Korean Won',
    'en-GB': 'South Korean Won',
    'en-IN': 'South Korean Won',
    'en-NG': 'South Korean Won',
    'en-SG': 'South Korean Won',
    'en-US': 'South Korean Won',
    'en-ZA': 'South Korean Won',
    'es-CL': 'Won surcoreano',
    'es-CO': 'Won surcoreano',
    'es-ES': 'Won surcoreano',
    'es-MX': 'Won surcoreano',
    'es-US': 'Won surcoreano',
    'fr-BE': 'Won sud-coréen',
    'fr-CA': 'Wons sud-coréens',
    'fr-FR': 'Won sud-coréen',
    'he-IL': 'וון דרום קוריאני',
    'hi-IN': 'दक्षिण कोरियाई वॉन',
    'it-IT': 'Won sudcoreano',
    'ja-JP': '大韓民国ウォン',
    'kn-IN': 'ದಕ್ಷಿಣ ಕೊರಿಯಾದ್ ವೊನ್',
    'ko-KR': '대한민국 원',
    'ml-IN': 'ദക്ഷിണ കൊറിയൻ വോൺ',
    'mr-IN': 'दक्षिण कोरियन वोन',
    'nl-BE': 'Zuid-Koreaanse won',
    'nl-NL': 'Zuid-Koreaanse won',
    'pl-PL': 'Won południowokoreański',
    'pt-BR': 'Won sul-coreano',
    'pt-PT': 'Won sul-coreano',
    'sv-SE': 'Sydkoreansk won',
    'ta-IN': 'தென்கொரியன் வோன்',
    'te-IN': 'సౌత్ కొరియన్ వోన్',
    'tr-TR': 'Güney Kore Wonu',
    'zh-CN': '韩元',
    'zh-TW': '韓圜',
  },
  'currency-selector-MXN': {
    'ar-AE': 'بيزو مكسيكي',
    'bn-IN': 'মেক্সিকান পেসো',
    'cs-CZ': 'Mexické peso',
    'da-DK': 'Mexicanske pesos',
    'de-DE': 'Mexikanische Pesos',
    'en-AE': 'Mexican Peso',
    'en-AU': 'Mexican Peso',
    'en-CA': 'Mexican Peso',
    'en-GB': 'Mexican Peso',
    'en-IN': 'Mexican Peso',
    'en-NG': 'Mexican Peso',
    'en-SG': 'Mexican Peso',
    'en-US': 'Mexican Peso',
    'en-ZA': 'Mexican Peso',
    'es-CL': 'Peso mexicano',
    'es-CO': 'Peso mexicano',
    'es-ES': 'Peso mexicano',
    'es-MX': 'Peso mexicano',
    'es-US': 'Peso mexicano',
    'fr-BE': 'Peso mexicain',
    'fr-CA': 'Pesos mexicain',
    'fr-FR': 'Peso mexicain',
    'he-IL': 'פסו מקסיקני',
    'hi-IN': 'मैक्सिकन पेसो',
    'it-IT': 'Peso messicano',
    'ja-JP': 'メキシコペソ',
    'kn-IN': 'ಮೆಕ್ಸಿಕನ್ ಪೆಸೊ',
    'ko-KR': '멕시코 페소',
    'ml-IN': 'മെക്സിക്കൻ പെസോ',
    'mr-IN': 'मेक्सिकन पेसो',
    'nl-BE': 'Mexicaanse peso',
    'nl-NL': 'Mexicaanse peso',
    'pl-PL': 'Peso meksykańskie',
    'pt-BR': 'Peso mexicano',
    'pt-PT': 'Peso mexicano',
    'sv-SE': 'Mexikansk peso',
    'ta-IN': 'மெக்சிகன் பெசோ',
    'te-IN': 'మెక్సికన్ పెసో',
    'tr-TR': 'Meksika Pesosu',
    'zh-CN': '墨西哥比索',
    'zh-TW': '墨西哥披索',
  },
  'currency-selector-MYR': {
    'ar-AE': 'رينغيت ماليزي',
    'bn-IN': 'মালয়েশিয়ান রিঙ্গিত',
    'cs-CZ': 'Malajsijský ringgit',
    'da-DK': 'Malaysiske ringgit',
    'de-DE': 'Malaysischer Ringgit',
    'en-AE': 'Malaysian Ringgit',
    'en-AU': 'Malaysian Ringgit',
    'en-CA': 'Malaysian Ringgit',
    'en-GB': 'Malaysian Ringgit',
    'en-IN': 'Malaysian Ringgit',
    'en-NG': 'Malaysian Ringgit',
    'en-SG': 'Malaysian Ringgit',
    'en-US': 'Malaysian Ringgit',
    'en-ZA': 'Malaysian Ringgit',
    'es-CL': 'Ringgit malayo',
    'es-CO': 'Ringgit malayo',
    'es-ES': 'Ringgit malasio',
    'es-MX': 'Ringgit malayo',
    'es-US': 'Ringgit malayo',
    'fr-BE': 'Ringgit malais',
    'fr-CA': 'Ringgit malaisien',
    'fr-FR': 'Ringgit malais',
    'he-IL': 'רינגיט מלזי',
    'hi-IN': 'मलेशियाई रिंगिट',
    'it-IT': 'Ringgit malese',
    'ja-JP': 'マレーシアリンギット',
    'kn-IN': 'ಮಲೇಷ್ಯಾದ ರಿಂಗಿಟ್',
    'ko-KR': '말레이시아 링깃',
    'ml-IN': 'മലേഷ്യൻ റിംഗിറ്റ്',
    'mr-IN': 'मलेशियन रिंगिट',
    'nl-BE': 'Maleisische ringgit',
    'nl-NL': 'Maleisische ringgit',
    'pl-PL': 'Ringgit malezyjski',
    'pt-BR': 'Ringgit da Malásia',
    'pt-PT': 'Ringgit da Malásia',
    'sv-SE': 'Malaysisk ringgit',
    'ta-IN': 'மலேசியன் ரிங்கிட்',
    'te-IN': 'మలేషియన్ రింగిట్',
    'tr-TR': 'Malezya Ringgiti',
    'zh-CN': '马来西亚林吉特',
    'zh-TW': '馬來西亞令吉',
  },
  'currency-selector-NGN': {
    'ar-AE': 'نيرة نيجيرية',
    'bn-IN': 'নাইজেরিয়ান নায়রা',
    'cs-CZ': 'Nigerijská naira',
    'da-DK': 'Nigerianske naira',
    'de-DE': 'Nigerianischer Naira',
    'en-AE': 'Nigerian Naira',
    'en-AU': 'Nigerian Naira',
    'en-CA': 'Nigerian Naira',
    'en-GB': 'Nigerian Naira',
    'en-IN': 'Nigerian Naira',
    'en-NG': 'Nigerian Naira',
    'en-SG': 'Nigerian Naira',
    'en-US': 'Nigerian Naira',
    'en-ZA': 'Nigerian Naira',
    'es-CL': 'Naira nigeriano',
    'es-CO': 'Naira nigeriano',
    'es-ES': 'Naira nigeriano',
    'es-MX': 'Naira nigeriano',
    'es-US': 'Naira nigeriano',
    'fr-BE': 'Naira nigérian',
    'fr-CA': 'Naira nigérian',
    'fr-FR': 'Naira nigérian',
    'he-IL': 'נאירה ניגרית',
    'hi-IN': 'नाइजीरियाई नाइरा',
    'it-IT': 'Naira nigeriana',
    'ja-JP': 'ナイジェリアナイラ',
    'kn-IN': 'ನೈಜೀರಿಯಾದ ನೈರಾ',
    'ko-KR': '나이지리아 나이라',
    'ml-IN': 'നൈജീരിയൻ നെയ്റ',
    'mr-IN': 'नायजेरियन नायरा',
    'nl-BE': 'Nigeriaanse naira',
    'nl-NL': 'Nigeriaanse naira',
    'pl-PL': 'Naira nigeryjska',
    'pt-BR': 'Naira nigeriana',
    'pt-PT': 'Naira da Nigéria',
    'sv-SE': 'Nigeriansk naira',
    'ta-IN': 'நைஜீரியன் நைரா',
    'te-IN': 'నైజీరియన్ నైరా',
    'tr-TR': 'Nijerya Nairası',
    'zh-CN': '尼日利亚奈拉',
    'zh-TW': '奈及利亞奈拉',
  },
  'currency-selector-NZD': {
    'ar-AE': 'دولار نيوزيلندي',
    'bn-IN': 'নিউজিল্যান্ড ডলার',
    'cs-CZ': 'Novozélandský dolar',
    'da-DK': 'New Zealandske dollar',
    'de-DE': 'Neuseeland-Dollar',
    'en-AE': 'New Zealand Dollar',
    'en-AU': 'New Zealand Dollar',
    'en-CA': 'New Zealand Dollar',
    'en-GB': 'New Zealand Dollar',
    'en-IN': 'New Zealand Dollar',
    'en-NG': 'New Zealand Dollar',
    'en-SG': 'New Zealand Dollar',
    'en-US': 'New Zealand Dollar',
    'en-ZA': 'New Zealand Dollar',
    'es-CL': 'Dólar neozelandés',
    'es-CO': 'Dólar neozelandés',
    'es-ES': 'Dólar neozelandés',
    'es-MX': 'Dólar neozelandés',
    'es-US': 'Dólar neozelandés',
    'fr-BE': 'Dollar néo-zélandais',
    'fr-CA': 'Dollar néo-zélandais',
    'fr-FR': 'Dollar néo-zélandais',
    'he-IL': 'דולר ניו זילנדי',
    'hi-IN': 'न्यूज़ीलैंड डॉलर',
    'it-IT': 'Dollaro neozelandese',
    'ja-JP': 'ニュージーランドドル',
    'kn-IN': 'ನ್ಯೂಜಿಲೆಂಡ್ ಡಾಲರ್',
    'ko-KR': '뉴질랜드 달러',
    'ml-IN': 'ന്യൂസിലൻഡ് ഡോളർ',
    'mr-IN': 'न्युझीलंड डॉलर',
    'nl-BE': 'Nieuw-Zeelandse dollar',
    'nl-NL': 'Nieuw-Zeelandse dollar',
    'pl-PL': 'Dolar nowozelandzki',
    'pt-BR': 'Dólar neozelandês',
    'pt-PT': 'Dólar neozelandês',
    'sv-SE': 'Nyzeeländsk dollar',
    'ta-IN': 'நியூசிலாந்து டாலர்',
    'te-IN': 'న్యూజిలాండ్ డాలర్',
    'tr-TR': 'Yeni Zelanda Doları',
    'zh-CN': '新西兰元',
    'zh-TW': '紐西蘭幣',
  },
  'currency-selector-PKR': {
    'ar-AE': 'روبية باكستانية',
    'bn-IN': 'পাকিস্তানি টাকা',
    'cs-CZ': 'Pákistánská rupie',
    'da-DK': 'Pakistanske rupee',
    'de-DE': 'Pakistanische Rupie',
    'en-AE': 'Pakistani Rupee',
    'en-AU': 'Pakistani Rupee',
    'en-CA': 'Pakistani Rupee',
    'en-GB': 'Pakistani Rupee',
    'en-IN': 'Pakistani Rupee',
    'en-NG': 'Pakistani Rupee',
    'en-SG': 'Pakistani Rupee',
    'en-US': 'Pakistani Rupee',
    'en-ZA': 'Pakistani Rupee',
    'es-CL': 'Rupia pakistaní',
    'es-CO': 'Rupia pakistaní',
    'es-ES': 'Rupia pakistaní',
    'es-MX': 'Rupia pakistaní',
    'es-US': 'Rupia pakistaní',
    'fr-BE': 'Roupie pakistanaise',
    'fr-CA': 'Roupie pakistanaise',
    'fr-FR': 'Roupie pakistanaise',
    'he-IL': 'רופי פקיסטני',
    'hi-IN': 'पाकिस्तानी रुपया',
    'it-IT': 'Rupia pakistana',
    'ja-JP': 'パキスタンルピー',
    'kn-IN': 'ಪಾಕಿಸ್ತಾನಿ ರೂಪಾಯಿ',
    'ko-KR': '파키스탄 루피',
    'ml-IN': 'പാക്കിസ്ഥാനി രൂപ',
    'mr-IN': 'पाकिस्तानी रुपया',
    'nl-BE': 'Pakistaanse roepie',
    'nl-NL': 'Pakistaanse roepie',
    'pl-PL': 'Rupia pakistańska',
    'pt-BR': 'Rúpia paquistanesa',
    'pt-PT': 'Rupia paquistanesa',
    'sv-SE': 'Pakistansk rupie',
    'ta-IN': 'பாகிஸ்தான் ரூபாய்',
    'te-IN': 'పాకిస్థానీ రూపీ',
    'tr-TR': 'Pakistan Rupisi',
    'zh-CN': '巴基斯坦卢比',
    'zh-TW': '巴基斯坦盧比',
  },
  'currency-selector-PLN': {
    'ar-AE': 'زلوتي بولندي',
    'bn-IN': 'পোলিশ জ্লোটি',
    'cs-CZ': 'Polský zlotý',
    'da-DK': 'Polske złoty',
    'de-DE': 'Polnischer Zloty',
    'en-AE': 'Polish Złoty',
    'en-AU': 'Polish Złoty',
    'en-CA': 'Polish Złoty',
    'en-GB': 'Polish Złoty',
    'en-IN': 'Polish Złoty',
    'en-NG': 'Polish Złoty',
    'en-SG': 'Polish Złoty',
    'en-US': 'Polish Złoty',
    'en-ZA': 'Polish Złoty',
    'es-CL': 'Esloti polaco',
    'es-CO': 'Esloti polaco',
    'es-ES': 'Esloti polaco',
    'es-MX': 'Zloty polaco',
    'es-US': 'Esloti polaco',
    'fr-BE': 'Złoty polonais',
    'fr-CA': 'Złoty polonais',
    'fr-FR': 'Złoty polonais',
    'he-IL': 'זלוטי פולני',
    'hi-IN': 'Polish Złoty',
    'it-IT': 'Złoty polacco',
    'ja-JP': 'ポーランドズウォティ',
    'kn-IN': 'ಪೋಲಿಷ್ ಜ್ಲಾಟಿ',
    'ko-KR': '폴란드 즈워티',
    'ml-IN': 'പോളിഷ് സ്ലോട്ടി',
    'mr-IN': 'पोलिश झुवॉटी',
    'nl-BE': 'Poolse zloty',
    'nl-NL': 'Poolse zloty',
    'pl-PL': 'Złoty polski',
    'pt-BR': 'Zloty polonês',
    'pt-PT': 'Zloty polaco',
    'sv-SE': 'Polsk złoty',
    'ta-IN': 'போலிஷ் ஸ்லோட்டி',
    'te-IN': 'పోలిష్ జ్లోటీ',
    'tr-TR': 'Polonya Zlotisi',
    'zh-CN': '波兰兹罗提',
    'zh-TW': '波蘭茲羅提',
  },
  'currency-selector-RON': {
    'ar-AE': 'ليو روماني',
    'bn-IN': 'রোমানিয়ান লিউ',
    'cs-CZ': 'Rumunský lei',
    'da-DK': 'Rumænske lei',
    'de-DE': 'Rumänischer Leu',
    'en-AE': 'Romanian Leu',
    'en-AU': 'Romanian Leu',
    'en-CA': 'Romanian Leu',
    'en-GB': 'Romanian Leu',
    'en-IN': 'Romanian Leu',
    'en-NG': 'Romanian Leu',
    'en-SG': 'Romanian Leu',
    'en-US': 'Romanian Leu',
    'en-ZA': 'Romanian Leu',
    'es-CL': 'Leu rumano',
    'es-CO': 'Leu rumano',
    'es-ES': 'Leu rumano',
    'es-MX': 'Leu rumano',
    'es-US': 'Leu rumano',
    'fr-BE': 'Leu roumain',
    'fr-CA': 'Lei roumains',
    'fr-FR': 'Leu roumain',
    'he-IL': 'לאו רומני',
    'hi-IN': 'रोमानियाई ल्यू',
    'it-IT': 'Leu romeno',
    'ja-JP': 'ルーマニアレウ',
    'kn-IN': 'ರೊಮೇನಿಯನ್ ಲ್ಯು',
    'ko-KR': '루마니아 레우',
    'ml-IN': 'റൊമാനിയൻ ലിയു',
    'mr-IN': 'रोमेनियन ल्यू',
    'nl-BE': 'Roemeense leus',
    'nl-NL': 'Roemeense leu',
    'pl-PL': 'Lej rumuński',
    'pt-BR': 'Leu romeno',
    'pt-PT': 'Leu romeno',
    'sv-SE': 'Rumänsk leu',
    'ta-IN': 'ரோமானிய லியூ',
    'te-IN': 'రొమానియన్ ల్యూ',
    'tr-TR': 'Rumen Leyi',
    'zh-CN': '罗马尼亚列伊',
    'zh-TW': '羅馬尼亞雷',
  },
  'currency-selector-SAR': {
    'ar-AE': 'ريال سعودي',
    'bn-IN': 'সৌদি রিয়াল',
    'cs-CZ': 'Saúdský rial',
    'da-DK': 'Saudiarabiske royal',
    'de-DE': 'Saudi-Riyal',
    'en-AE': 'Saudi Riyal',
    'en-AU': 'Saudi Riyal',
    'en-CA': 'Saudi Riyal',
    'en-GB': 'Saudi Riyals',
    'en-IN': 'Saudi Riyal',
    'en-NG': 'Saudi Riyal',
    'en-SG': 'Saudi Riyal',
    'en-US': 'Saudi Riyal',
    'en-ZA': 'Saudi Riyal',
    'es-CL': 'Riyal saudí',
    'es-CO': 'Riyal saudí',
    'es-ES': 'Rial saudí',
    'es-MX': 'Riyal saudí',
    'es-US': 'Riyal saudí',
    'fr-BE': 'Riyal saoudien',
    'fr-CA': 'Riyal saoudien',
    'fr-FR': 'Riyal saoudien',
    'he-IL': 'ריאל סעודי',
    'hi-IN': 'सऊदी रियाल',
    'it-IT': 'Rial saudita',
    'ja-JP': 'サウジアラビアリヤル',
    'kn-IN': 'ಸೌದಿ ರಿಯಾಲ್',
    'ko-KR': '사우디 리얄',
    'ml-IN': 'സൗദി റിയാൽ',
    'mr-IN': 'सौदी रियाल',
    'nl-BE': 'Saoedische riyal',
    'nl-NL': 'Saoedische riyal',
    'pl-PL': 'Rial saudyjski',
    'pt-BR': 'Rial saudita',
    'pt-PT': 'Rial da Arábia Saudita',
    'sv-SE': 'Saudiarabisk riyal',
    'ta-IN': 'சவுதி ரியால்',
    'te-IN': 'సౌదీ రియాల్',
    'tr-TR': 'Suudi Arabistan Riyali',
    'zh-CN': '沙特里亚尔',
    'zh-TW': '沙烏地里亞爾',
  },
  'currency-selector-SEK': {
    'ar-AE': 'كرونة سويدية',
    'bn-IN': 'সুইডিশ ক্রোনা',
    'cs-CZ': 'Švédská koruna',
    'da-DK': 'Svenske kroner',
    'de-DE': 'Schwedische Kronen',
    'en-AE': 'Swedish Krona',
    'en-AU': 'Swedish Krona',
    'en-CA': 'Swedish Krona',
    'en-GB': 'Swedish Krona',
    'en-IN': 'Swedish Krona',
    'en-NG': 'Swedish Krona',
    'en-SG': 'Swedish Krona',
    'en-US': 'Swedish Krona',
    'en-ZA': 'Swedish Krona',
    'es-CL': 'Corona sueca',
    'es-CO': 'Corona sueca',
    'es-ES': 'Corona sueca',
    'es-MX': 'Corona sueca',
    'es-US': 'Corona sueca',
    'fr-BE': 'Couronne suédoise',
    'fr-CA': 'Couronne suédoise',
    'fr-FR': 'Couronne suédoise',
    'he-IL': 'קרונה שוודית',
    'hi-IN': 'स्वीडिश क्रोना',
    'it-IT': 'Corona svedese',
    'ja-JP': 'スウェーデンクローナ',
    'kn-IN': 'ಸ್ವೀಡಿಷ್ ಕ್ರೋನಾ',
    'ko-KR': '스웨덴 크로나',
    'ml-IN': 'സ്വീഡിഷ് ക്രോണ',
    'mr-IN': 'स्वीडिश क्रोना',
    'nl-BE': 'Zweedse kroon',
    'nl-NL': 'Zweedse kroon',
    'pl-PL': 'Korona szwedzka',
    'pt-BR': 'Coroa da Suécia',
    'pt-PT': 'Coroa sueca',
    'sv-SE': 'Svensk krona',
    'ta-IN': 'ஸ்வீடிஷ் க்ரூன',
    'te-IN': 'స్వీడిష్ క్రోనా',
    'tr-TR': 'İsveç Kronu',
    'zh-CN': '瑞典克朗',
    'zh-TW': '瑞典克朗',
  },
  'currency-selector-SGD': {
    'ar-AE': 'دولار سنغافوري',
    'bn-IN': 'সিঙ্গাপুর ডলার',
    'cs-CZ': 'Singapurský dolar',
    'da-DK': 'Singapore-dollar',
    'de-DE': 'Singapur-Dollar',
    'en-AE': 'Singapore Dollar',
    'en-AU': 'Singapore Dollar',
    'en-CA': 'Singapore Dollar',
    'en-GB': 'Singapore Dollar',
    'en-IN': 'Singapore Dollar',
    'en-NG': 'Singapore Dollar',
    'en-SG': 'Singapore Dollar',
    'en-US': 'Singapore Dollar',
    'en-ZA': 'Singapore Dollar',
    'es-CL': 'Dólar de Singapur',
    'es-CO': 'Dólar de Singapur',
    'es-ES': 'Dólar de Singapur',
    'es-MX': 'Dólar singapurense',
    'es-US': 'Dólar de Singapur',
    'fr-BE': 'Dollar de Singapour',
    'fr-CA': 'Dollar de Singapour',
    'fr-FR': 'Dollar de Singapour',
    'he-IL': 'דולר סינגפורי',
    'hi-IN': 'सिंगापुर डॉलर',
    'it-IT': 'Dollaro di Singapore',
    'ja-JP': 'シンガポールドル',
    'kn-IN': 'ಸಿಂಗಾಪುರದ ಡಾಲರ್',
    'ko-KR': '싱가포르 달러',
    'ml-IN': 'സിംഗപ്പൂർ ഡോളർ',
    'mr-IN': 'सिंगापूर डॉलर',
    'nl-BE': 'Singaporese dollar',
    'nl-NL': 'Singaporese dollar',
    'pl-PL': 'Dolar singapurski',
    'pt-BR': 'Dólar de Cingapura',
    'pt-PT': 'Dólar de Singapura',
    'sv-SE': 'Singaporiansk dollar',
    'ta-IN': 'சிங்கப்பூர் டாலர்',
    'te-IN': 'సింగపూర్ డాలర్',
    'tr-TR': 'Singapur Doları',
    'zh-CN': '新加坡元',
    'zh-TW': '新加坡幣',
  },
  'currency-selector-THB': {
    'ar-AE': 'بات تايلاندي',
    'bn-IN': 'থাই বাট',
    'cs-CZ': 'Thajský baht',
    'da-DK': 'Thailandske baht',
    'de-DE': 'Thailändischer Baht',
    'en-AE': 'Thai Baht',
    'en-AU': 'Thai Baht',
    'en-CA': 'Thai Baht',
    'en-GB': 'Thai Baht',
    'en-IN': 'Thai Baht',
    'en-NG': 'Thai Baht',
    'en-SG': 'Thai Baht',
    'en-US': 'Thai Baht',
    'en-ZA': 'Thai Baht',
    'es-CL': 'Baht tailandés',
    'es-CO': 'Baht tailandés',
    'es-ES': 'Baht tailandés',
    'es-MX': 'Baht tailandés',
    'es-US': 'Baht tailandés',
    'fr-BE': 'Baht thaïlandais',
    'fr-CA': 'Baht de la Thaïlande',
    'fr-FR': 'Baht thaïlandais',
    'he-IL': 'באט תאילנדי',
    'hi-IN': 'थाई बाट',
    'it-IT': 'Baht thailandese',
    'ja-JP': 'タイバーツ',
    'kn-IN': 'ಥಾಯ್ ಭಾಹ್ತ್',
    'ko-KR': '태국 바트',
    'ml-IN': 'തായ് ബാട്ട്',
    'mr-IN': 'थाई बाट',
    'nl-BE': 'Thaise baht',
    'nl-NL': 'Thaise baht',
    'pl-PL': 'Bat tajlandzki',
    'pt-BR': 'Baht tailandês',
    'pt-PT': 'Baht da Tailândia',
    'sv-SE': 'Thailändsk baht',
    'ta-IN': 'தாய் பாஹ்ட்',
    'te-IN': 'థాయ్ బాట్',
    'tr-TR': 'Tayland Bahtı',
    'zh-CN': '泰铢',
    'zh-TW': '泰銖',
  },
  'currency-selector-TRY': {
    'ar-AE': 'ليرة تركية',
    'bn-IN': 'টার্কিশ লিরা',
    'cs-CZ': 'Turecká lira',
    'da-DK': 'Tyrkiske lira',
    'de-DE': 'Türkische Lira',
    'en-AE': 'Turkish Lira',
    'en-AU': 'Turkish Lira',
    'en-CA': 'Turkish Lira',
    'en-GB': 'Turkish Lira',
    'en-IN': 'Turkish Lira',
    'en-NG': 'Turkish Lira',
    'en-SG': 'Turkish Lira',
    'en-US': 'Turkish Lira',
    'en-ZA': 'Turkish Lira',
    'es-CL': 'Lira turca',
    'es-CO': 'Lira turca',
    'es-ES': 'Lira turca',
    'es-MX': 'Lira turca',
    'es-US': 'Lira turca',
    'fr-BE': 'Lire turque',
    'fr-CA': 'Livre turque',
    'fr-FR': 'Lire turque',
    'he-IL': 'לירה טורקית',
    'hi-IN': 'तुर्की लीरा',
    'it-IT': 'Lira turca',
    'ja-JP': 'トルコリラ',
    'kn-IN': 'ಟರ್ಕಿಶ್ ಲಿರಾ',
    'ko-KR': '터키 리라',
    'ml-IN': 'ടർക്കിഷ് ലിറ',
    'mr-IN': 'तुर्की लिरा',
    'nl-BE': 'Turkse lira',
    'nl-NL': 'Turkse lira',
    'pl-PL': 'Lira turecka',
    'pt-BR': 'Lira turca',
    'pt-PT': 'Lira turca',
    'sv-SE': 'Turkisk lira',
    'ta-IN': 'டர்கிஷ் லிரா',
    'te-IN': 'టర్కిష్ లీరా',
    'tr-TR': 'Türk Lirası',
    'zh-CN': '土耳其里拉',
    'zh-TW': '土耳其里拉',
  },
  'currency-selector-TWD': {
    'ar-AE': 'دولار تايواني جديد',
    'bn-IN': 'নতুন তাইওয়ান ডলার',
    'cs-CZ': 'Nový tchajwanský dolar',
    'da-DK': 'Nye taiwansk dollar',
    'de-DE': 'Neuer Taiwan-Dollar',
    'en-AE': 'New Taiwan Dollar',
    'en-AU': 'New Taiwan Dollar',
    'en-CA': 'New Taiwan Dollar',
    'en-GB': 'New Taiwan Dollar',
    'en-IN': 'New Taiwan Dollar',
    'en-NG': 'New Taiwan Dollar',
    'en-SG': 'New Taiwan Dollar',
    'en-US': 'New Taiwan Dollar',
    'en-ZA': 'New Taiwan Dollar',
    'es-CL': 'Nuevo dólar taiwanés',
    'es-CO': 'Nuevo dólar taiwanés',
    'es-ES': 'Nuevo dólar taiwanés',
    'es-MX': 'Nuevo dólar taiwanés',
    'es-US': 'Nuevo dólar taiwanés',
    'fr-BE': 'Nouveau dollar de Taïwan',
    'fr-CA': 'Nouveaux dollars taïwanais',
    'fr-FR': 'Nouveau dollar de Taïwan',
    'he-IL': 'דולר טייוואני חדש',
    'hi-IN': 'नया ताइवान डॉलर',
    'it-IT': 'Nuovo dollaro taiwanese',
    'ja-JP': '新台湾ドル',
    'kn-IN': 'ನ್ಯೂ ತೈವಾನ್ ಡಾಲರ್‌',
    'ko-KR': '신 타이완 달러',
    'ml-IN': 'ന്യൂ തായ്‌വാൻ ഡോളർ',
    'mr-IN': 'नवीन तैवान डॉलर',
    'nl-BE': 'Nieuwe Taiwanese dollar',
    'nl-NL': 'Nieuwe Taiwanese dollar',
    'pl-PL': 'Dolar tajwański',
    'pt-BR': 'Novo dólar taiwanês',
    'pt-PT': 'Novo dólar de Taiwan',
    'sv-SE': 'Taiwanesisk dollar',
    'ta-IN': 'நியூ தைவான் டாலர்',
    'te-IN': 'న్యూ తైవాన్ డాలర్‌',
    'tr-TR': 'Yeni Tayvan Doları',
    'zh-CN': '新台币',
    'zh-TW': '新台幣',
  },
  'currency-selector-UAH': {
    'ar-AE': 'هريفنيا أوكرانية',
    'bn-IN': 'ইউক্রেনীয় রিভনিয়া',
    'cs-CZ': 'Ukrajinská hřivna',
    'da-DK': 'Ukrainske Hryvnia',
    'de-DE': 'Ukrainische Hrywnja',
    'en-AE': 'Ukrainian Hryvnia',
    'en-AU': 'Ukrainian Hryvnia',
    'en-CA': 'Ukrainian Hryvnia',
    'en-GB': 'Ukrainian Hryvnia',
    'en-IN': 'Ukrainian Hryvnia',
    'en-NG': 'Ukrainian Hryvnia',
    'en-SG': 'Ukrainian Hryvnia',
    'en-US': 'Ukrainian Hryvnia',
    'en-ZA': 'Ukrainian Hryvnia',
    'es-CL': 'Grivnia ucraniana',
    'es-CO': 'Grivna ucraniana​',
    'es-ES': 'Grivna ucraniana',
    'es-MX': 'Grivna ucraniana​',
    'es-US': 'Grivna ucraniana',
    'fr-BE': 'Hryvnia ukrainienne',
    'fr-CA': 'Hryvnia ukrainien',
    'fr-FR': 'Hryvnia ukrainienne',
    'he-IL': 'גריבנה אוקראינית',
    'hi-IN': 'यूक्रेनी रिव्निया',
    'it-IT': 'Grivnia ucraina',
    'ja-JP': 'ウクライナフリヴニャ',
    'kn-IN': 'ಉಕ್ರೇನಿಯನ್ ಹರೀವ್ನಿಯಾ',
    'ko-KR': '우크라이나 흐리우냐',
    'ml-IN': 'ഉക്രേനിയൻ ഹ്രിവ്നിയ',
    'mr-IN': 'युक्रेनियन रिउनिया',
    'nl-BE': 'Oekraïense hryvnia',
    'nl-NL': 'Oekraïense hryvnia',
    'pl-PL': 'Hrywna ukraińska',
    'pt-BR': 'Grívnia ucraniana',
    'pt-PT': 'Hryvnia da Ucrânia',
    'sv-SE': 'Ukrainsk hryvnia',
    'ta-IN': 'உக்ரைனியன் ஹ்ரிவ்னியா',
    'te-IN': 'ఉక్రెయినియన్ హైవినియా',
    'tr-TR': 'Ukrayna Grivnası',
    'zh-CN': '乌克兰格里夫纳',
    'zh-TW': '烏克蘭荷林夫納',
  },
  'currency-selector-USD': {
    'ar-AE': 'دولار أمريكي',
    'bn-IN': 'মার্কিন ডলার',
    'cs-CZ': 'Americké dolary',
    'da-DK': 'Amerikanske dollars',
    'de-DE': 'US-Dollar',
    'en-AE': 'United States Dollars',
    'en-AU': 'United States Dollars',
    'en-CA': 'United States Dollars',
    'en-GB': 'United States Dollars',
    'en-IN': 'United States Dollar',
    'en-NG': 'United States Dollars',
    'en-SG': 'United States Dollars',
    'en-US': 'United States Dollars',
    'en-ZA': 'United States Dollars',
    'es-CL': 'Dólar estadounidense',
    'es-CO': 'Dólares estadounidenses',
    'es-ES': 'Dólares estadounidenses',
    'es-MX': 'Dólares estadounidenses',
    'es-US': 'Dólar estadounidense',
    'fr-BE': 'Dollars américains',
    'fr-CA': 'Dollars américains',
    'fr-FR': 'Dollars américains',
    'he-IL': 'דולר ארה"ב',
    'hi-IN': 'यूनाइटेड स्टेट्स डॉलर',
    'it-IT': 'Dollari statunitensi',
    'ja-JP': '米国ドル',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಸ್ಟೇಟ್ಸ್ ಡಾಲರ್‌ಗಳು',
    'ko-KR': '미국 달러',
    'ml-IN': 'യുണൈറ്റഡ് സ്റ്റേറ്റ്സ് ഡോളർ',
    'mr-IN': 'युनायटेड स्टेट्स डॉलर',
    'nl-BE': 'Amerikaanse dollars',
    'nl-NL': 'Amerikaanse dollar',
    'pl-PL': 'Dolar amerykański',
    'pt-BR': 'Dólares dos Estados Unidos',
    'pt-PT': 'Dólar americano',
    'sv-SE': 'Amerikansk dollar',
    'ta-IN': 'அமெரிக்க டாலர்கள்',
    'te-IN': 'యునైటెడ్ సేట్స్ డాలర్స్',
    'tr-TR': 'Amerikan Doları',
    'zh-CN': '美元',
    'zh-TW': '美元',
  },
  'currency-selector-VND': {
    'ar-AE': 'دونغ فيتنامي',
    'bn-IN': 'ভিয়েতনামিজ ডং',
    'cs-CZ': 'Vietnamský dong',
    'da-DK': 'Vietnamesiske dong',
    'de-DE': 'Vietnamesischer Dong',
    'en-AE': 'Vietnamese Dong',
    'en-AU': 'Vietnamese Dong',
    'en-CA': 'Vietnamese Dong',
    'en-GB': 'Vietnamese Dong',
    'en-IN': 'Vietnamese Dong',
    'en-NG': 'Vietnamese Dong',
    'en-SG': 'Vietnamese Dong',
    'en-US': 'Vietnamese Dong',
    'en-ZA': 'Vietnamese Dong',
    'es-CL': 'Dong vietnamita',
    'es-CO': 'Dong vietnamita',
    'es-ES': 'Dong vietnamita',
    'es-MX': 'Dong vietnamita',
    'es-US': 'Dong vietnamita',
    'fr-BE': 'Dong vietnamien',
    'fr-CA': 'Dong vietnamien',
    'fr-FR': 'Dong vietnamien',
    'he-IL': 'דונג וייאטנמי',
    'hi-IN': 'वियतनामी डोंग',
    'it-IT': 'Dong vietnamita',
    'ja-JP': 'ベトナムドン',
    'kn-IN': 'ವಿಯೆಟ್ನಾಂನ ಡಾಂಗ್',
    'ko-KR': '베트남 동',
    'ml-IN': 'വിയറ്റ്നാമീസ് ഡോങ്ക്',
    'mr-IN': 'व्हिएतनामी डॉंंग',
    'nl-BE': 'Vietnamese dong',
    'nl-NL': 'Vietnamese dong',
    'pl-PL': 'Dong wietnamski',
    'pt-BR': 'Dong vietnamita',
    'pt-PT': 'Dong do Vietname',
    'sv-SE': 'Vietnamesisk dong',
    'ta-IN': 'வியட்நாமிஸ் டாங்',
    'te-IN': 'వియత్నమీస్ డాంగ్',
    'tr-TR': 'Vietnam Dongu',
    'zh-CN': '越南盾',
    'zh-TW': '越南盾',
  },
  'currency-selector-ZAR': {
    'ar-AE': 'راند جنوب أفريقي',
    'bn-IN': 'দক্ষিণ আফ্রিকান র‍্যান্ড',
    'cs-CZ': 'Jihoafrický rand',
    'da-DK': 'Sydafrikanske rand',
    'de-DE': 'Südafrikanischer Rand',
    'en-AE': 'South African Rand',
    'en-AU': 'South African Rand',
    'en-CA': 'South African Rand',
    'en-GB': 'South African Rand',
    'en-IN': 'South African Rand',
    'en-NG': 'South African Rand',
    'en-SG': 'South African Rand',
    'en-US': 'South African Rand',
    'en-ZA': 'South African Rand',
    'es-CL': 'Rand sudafricano',
    'es-CO': 'Rand sudafricano',
    'es-ES': 'Rand sudafricano',
    'es-MX': 'Rand sudafricano',
    'es-US': 'Rand sudafricano',
    'fr-BE': 'Rand sud-africain',
    'fr-CA': 'Rand sud-africain',
    'fr-FR': 'Rand sud-africain',
    'he-IL': 'ראנד דרום אפריקאי',
    'hi-IN': 'दक्षिण अफ़्रीकी रैंड',
    'it-IT': 'Rand sudafricano',
    'ja-JP': '南アフリカランド',
    'kn-IN': 'ದಕ್ಷಿಣ ಆಫ್ರಿಕಾದ ರ್ಯಾಂಡ್',
    'ko-KR': '남아프리카 공화국 랜드',
    'ml-IN': 'സൗത്ത് ആഫ്രിക്കൻ റാൻഡ്',
    'mr-IN': 'दक्षिण आफ्रिका रँड',
    'nl-BE': 'Zuid-Afrikaanse rand',
    'nl-NL': 'Zuid-Afrikaanse rand',
    'pl-PL': 'Rand południowoafrykański',
    'pt-BR': 'Rand sul-africano',
    'pt-PT': 'Rand sul-africano',
    'sv-SE': 'Sydafrikansk rand',
    'ta-IN': 'தென் ஆப்பிரிக்க ராண்ட்',
    'te-IN': 'సౌత్ ఆఫ్రికన్ ర్యాండ్',
    'tr-TR': 'Güney Afrika Randı',
    'zh-CN': '南非兰特',
    'zh-TW': '南非鍰',
  },
};

export default katTranslator(strings);
